<div class="h-[30rem]" [style]="{position: 'relative'}">
<canvas baseChart [data]="chartData()" [options]="chartOptions" type="line"></canvas>
</div>